export enum ActionTypes {
    UPDATE_FIELD = 'UPDATE_FIELD',
    SET_FORM_FIELDS = 'SET_FORM_FIELDS',
    RESET_FORM = 'RESET_FORM',
    SET_FILES = 'SET_FILES'
}